import { createFileRoute } from '@tanstack/react-router';
import { getGrokImageEditorSeoData } from '@/components/custom/grok-image-editor-seo-data';
import { GrokImageEditorRoute } from '@/components/custom/grok-image-editor-route';
import { validateImageEditorSearch } from '@/lib/image-editor-route-search';
import { seo } from '@/lib/seo';

export const Route = createFileRoute('/image-editor')({
  validateSearch: validateImageEditorSearch,
  loaderDeps: ({ search }) => ({
    creationId: search.creationId,
    promptId: search.promptId,
  }),
  loader: async ({ context, deps }) => {
    const promises: Promise<unknown>[] = [];
    if (deps.promptId) {
      const { getImagePromptById } = await import('@/api/image-prompts');
      promises.push(
        context.queryClient.prefetchQuery({
          queryKey: ['imagePromptDetail', deps.promptId],
          queryFn: () => getImagePromptById({ data: { id: deps.promptId! } }),
          staleTime: 5 * 60_000,
        })
      );
    }
    if (deps.creationId) {
      const { getCreation } = await import('@/api/creation');
      promises.push(
        context.queryClient.prefetchQuery({
          queryKey: ['creationDetail', deps.creationId],
          queryFn: () => getCreation({ data: { id: deps.creationId! } }),
          staleTime: 5 * 60_000,
        })
      );
    }
    await Promise.all(promises);
  },
  head: () => {
    const data = getGrokImageEditorSeoData();
    return seo(data.path, {
      title: data.seoTitle,
      description: data.seoDescription,
      keywords: data.keywords,
    });
  },
  component: GrokImageEditorRoute,
});
